var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 146.732,
    height: 63.316,
    viewBox: "0 0 146.732 63.316",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M116.021,43.322a12.753,12.753,0,1,0,9.6,21.134v1.363A9.6,9.6,0,0,1,108.429,71.7a1.576,1.576,0,1,0-2.491,1.931,12.753,12.753,0,0,0,22.836-7.808v-10.3a1.559,1.559,0,0,0-.033-.323A12.768,12.768,0,0,0,116.021,43.322Zm0,22.354a9.6,9.6,0,1,1,9.6-9.6A9.612,9.612,0,0,1,116.021,65.676Z",
    transform: "translate(-103.268 -42.768)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M158.723,43.322a12.768,12.768,0,0,0-12.746,12.311c0,.045-.007.09-.007.135s0,.064,0,.095c0,.071,0,.141,0,.212a12.753,12.753,0,0,0,22.1,8.676,1.576,1.576,0,0,0-2.31-2.145,9.6,9.6,0,0,1-16.549-5.22l20.668.265a1.556,1.556,0,0,0,1.128-.454,1.579,1.579,0,0,0,.469-1.122A12.767,12.767,0,0,0,158.723,43.322ZM149.3,54.235a9.6,9.6,0,0,1,18.891.242Z",
    transform: "translate(-103.268 -42.768)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M186.235,43.322a12.769,12.769,0,0,0-12.746,12.311c0,.045-.007.09-.007.135s0,.064,0,.095c0,.071,0,.141,0,.212a12.753,12.753,0,0,0,22.1,8.676,1.576,1.576,0,0,0-2.31-2.145,9.6,9.6,0,0,1-16.549-5.22l20.668.265a1.547,1.547,0,0,0,1.128-.454,1.579,1.579,0,0,0,.469-1.122A12.767,12.767,0,0,0,186.235,43.322Zm-9.424,10.913a9.6,9.6,0,0,1,18.891.242Z",
    transform: "translate(-103.268 -42.768)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M147.689,44.344a1.577,1.577,0,0,0-1.576-1.576A12.767,12.767,0,0,0,133.36,55.521V67.252a1.576,1.576,0,1,0,3.152,0V55.521a9.611,9.611,0,0,1,9.6-9.6A1.577,1.577,0,0,0,147.689,44.344Z",
    transform: "translate(-103.268 -42.768)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M211.168,43.035a9.612,9.612,0,0,0-9.6,9.6V67.252a1.577,1.577,0,0,0,3.153,0V52.636a6.448,6.448,0,1,1,12.9,0V67.252a1.576,1.576,0,1,0,3.152,0V52.636A9.612,9.612,0,0,0,211.168,43.035Z",
    transform: "translate(-103.268 -42.768)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M219.192,70.834a1.577,1.577,0,0,0-1.576,1.576V87.026a6.448,6.448,0,1,1-12.9,0V72.41a1.577,1.577,0,0,0-3.153,0V87.026a9.6,9.6,0,1,0,19.2,0V72.41A1.577,1.577,0,0,0,219.192,70.834Z",
    transform: "translate(-103.268 -42.768)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M236.96,70.547a13.054,13.054,0,0,0-13.039,13.04v20.921a1.576,1.576,0,1,0,3.152,0V92.074a13.036,13.036,0,1,0,9.887-21.527Zm0,22.927a9.887,9.887,0,1,1,9.888-9.887A9.9,9.9,0,0,1,236.96,93.474Z",
    transform: "translate(-103.268 -42.768)",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M209.591,72.267a11.848,11.848,0,0,0-1.432-3.152,16.3,16.3,0,0,0-1.147-1.433,6.266,6.266,0,0,0-.86,2.579,8.54,8.54,0,0,0,1.147,4.872,10.346,10.346,0,0,0,2.579,2.579c.573.573.573.747.573.747v8.854a.43.43,0,0,0,.86,0V80.9c.287-.605,1.433-.891,1.433-.891a4.915,4.915,0,0,0,1.719-1.147,3.506,3.506,0,0,0,1.147-2.292v-.287a5.626,5.626,0,0,0-2.579,1.147,4.87,4.87,0,0,0-1.72,2.865V71.18a4.264,4.264,0,0,1,.573-2.065c.573-.86,2.579-2.007,3.153-3.153a8.518,8.518,0,0,0,1.146-5.445c-.287-2.866-.573-3.439-.86-4.012s-.573-.86-1.146-.287-3.439,4.872-3.726,7.451a83.355,83.355,0,0,0,0,8.455v4.265A33.537,33.537,0,0,0,209.591,72.267Z",
    transform: "translate(-103.268 -42.768)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.fc5c04ced50f0fc5da6e4b1021db4007.svg";
export { ForwardRef as ReactComponent };